import templateUrl from '../../views/workflows/general/billing-document-type-modal.tpl.html';
import InvoiceTemplates from '../../../store/billing/invoice_templates';

class ConfigureBillingDocumentController {

    constructor(types, store, $uibModalInstance, InvoiceTemplate, $injector, $scope, $http) {
        this.types = types;
        this.store = store;
        this.modal = $uibModalInstance;
        this.invoiceTemplateModel = InvoiceTemplate;
        this.injector = $injector;
        this.scope = $scope;
        this.api = $http;
        this.selectedType = 'bid';
        this.selectedTemplateId = 0;
        this.selectedTemplate = null;

        this.resetData();
        this.initWatchers();
        this.resetTemplateSelectorConfig();
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.selectedType;
        }, () => {
            this.resetTemplateSelectorConfig();
        });

        this.scope.$watch(() => {
            return this.selectedTemplateId;
        }, () => {
            this.loadTemplateInformation();
        });
    }

    loadTemplateInformation() {
        this.selectedTemplate = null;
        this.resetData();
        if (this.selectedTemplateId && this.selectedTemplateId > 0) {
            this.api.get('billing/invoices/templates/' + this.selectedTemplateId).then((response) => {
                this.selectedTemplate = response.data.data;
                this.updateExtendedInformation();
            });
        }
    }

    resetData() {
        this.data = {
            invoice_template_id: 0,
            extended: {
                invoice_date: new Date(),
                shipping: true
            }
        };
    }

    submit() {
        const data = _.cloneDeep(this.data);
        data.type = this.selectedType;
        data.invoice_template_id = this.selectedTemplate.id;
        this.modal.close(data);
    }

    close() {
        this.modal.dismiss();
    }

    resetTemplateSelectorConfig() {
        this.templateSelectorConfig = null;
        this.invoiceTemplatesStore = (new InvoiceTemplates(this.invoiceTemplateModel, {
            injector: this.injector
        })).reset({
            persist: false,
            listname: 'SelectInvoiceTemplateStore'
        });

        const permanentFilters = {};
        permanentFilters['enable_for_' + this.selectedType] = true;
        this.invoiceTemplatesStore.commit('setPermanentFilters', permanentFilters);

        this.templateSelectorConfig = {
            store: this.invoiceTemplatesStore,
            displayField: 'title',
            valueField: 'id',
            labelField: 'label',
            searchField: 'title',
            sortField: {field: 'title', direction: 'asc'},
            type: this.selectedType
        };
    }

    updateExtendedInformation() {
        if (!this.selectedTemplate) {
            return;
        }

        const fieldsToCopyFromTemplate = [
            'subject',
            'number_circle_id',
            'text1',
            'text2',
            'text3',
            'tax_rate',
            'processing_costs_per_person',
            'processing_costs_general'
        ];

        _.each(fieldsToCopyFromTemplate, (fieldName) => {
            this.data.extended[fieldName] = this.selectedTemplate[fieldName];
        });
    }
}

ConfigureBillingDocumentController.$inject = [
    'types',
    'store',
    '$uibModalInstance',
    'InvoiceTemplate',
    '$injector',
    '$scope',
    '$http'
];

class CreateBillingDocumentsWorkflow {
    constructor(slug, Alert, $http, $uibModal, types) {
        this.slug = slug;
        this.alert = Alert;
        this.api = $http;
        this.modal = $uibModal;
        this.key = 'create-billing-documents';
        this.title = 'Create billing documents';
        this.level = 'selected';

        this.types = types || {
            bid: 'BID',
            invoice: 'Invoice'
        }
    }

    action({}, store) {
        return this.modal.open({
            templateUrl: templateUrl,
            controller: ConfigureBillingDocumentController,
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
                store: () => {
                    return store;
                },
                types: () => {
                    return this.types;
                }
            }
        }).result.then(data => {
            const request = {
                ...data
            };
            request[store.state.slug] = store.getters.selectedFilters;

            return this.api.post('billing/invoices/'+ store.getters.exportSlug + '/' + data.type, request)
                .then(
                    () => this.alert.success('Job started', 'The documents are getting generated right now. Please keep an eye up to the right corner, to see if it fails or finishes.'),
                    response => this.alert.handle(response)
                );
        }, response => this.alert.handle(response));
    }
}

export default CreateBillingDocumentsWorkflow;



// WEBPACK FOOTER //
// ./src/app/components/workflows/general/create-billing-documents-workflow.js